<div class="grid">
  <div class="col-12">
    <div class="recuadro-widget" style="width: 100%">
      <span class="recuadro-widget-icon bg-green"><i class="fa fa-calendar"></i></span>

      <div class="recuadro-widget-content">
        <span class="recuadro-widget-number">{{ (fechaUltimaSincronizacion ?? '---') }}</span>
        <span class="recuadro-widget-text">{{ 'WIDGETS.LBL_ULTIMASINCRONIZACION' | translate }}</span>
        <div style="display: flex;">
          <button style="width: 100%; margin-right: 10px; font-size: 12px;" *ngIf="!loading"
                  class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                  label="{{'BTN_ACTUALIZAR' | translate}}" type="button" pButton
                  (click)="actualizarInformacion()"></button>
          <div class="col-12 text-center" *ngIf="loading">
            <i class="fa fa-refresh fa-spin"></i> <span><strong>{{ 'LBL_PROCESANDO' | translate }}</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
